module.exports = __webpack_public_path__ + "img/contacto_16-9_960.943516bd.jpg";